export const montana = {
  "30000": "Montana",
  "30001": "Beaverhead County",
  "30003": "Big Horn County",
  "30005": "Blaine County",
  "30007": "Broadwater County",
  "30009": "Carbon County",
  "30011": "Carter County",
  "30013": "Cascade County",
  "30015": "Chouteau County",
  "30017": "Custer County",
  "30019": "Daniels County",
  "30021": "Dawson County",
  "30023": "Deer Lodge County",
  "30025": "Fallon County",
  "30027": "Fergus County",
  "30029": "Flathead County",
  "30031": "Gallatin County",
  "30033": "Garfield County",
  "30035": "Glacier County",
  "30037": "Golden Valley County",
  "30039": "Granite County",
  "30041": "Hill County",
  "30043": "Jefferson County",
  "30045": "Judith Basin County",
  "30047": "Lake County",
  "30049": "Lewis and Clark County",
  "30051": "Liberty County",
  "30053": "Lincoln County",
  "30055": "McCone County",
  "30057": "Madison County",
  "30059": "Meagher County",
  "30061": "Mineral County",
  "30063": "Missoula County",
  "30065": "Musselshell County",
  "30067": "Park County",
  "30069": "Petroleum County",
  "30071": "Phillips County",
  "30073": "Pondera County",
  "30075": "Powder River County",
  "30077": "Powell County",
  "30079": "Prairie County",
  "30081": "Ravalli County",
  "30083": "Richland County",
  "30085": "Roosevelt County",
  "30087": "Rosebud County",
  "30089": "Sanders County",
  "30091": "Sheridan County",
  "30093": "Silver Bow County",
  "30095": "Stillwater County",
  "30097": "Sweet Grass County",
  "30099": "Teton County",
  "30101": "Toole County",
  "30103": "Treasure County",
  "30105": "Valley County",
  "30107": "Wheatland County",
  "30109": "Wibaux County",
  "30111": "Yellowstone County",
  "30113": "Yellowstone National Park",
};
